import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Login from './components/Users/Forms/Login';
import Register from './components/Users/Forms/Register';
import VerifyEmail from './components/Users/Forms/VerifyEmail';
import RoomList from './components/Rooms/roomsList';
import BookingForm from './components/Bookings/bookingForm';
import MyBookings from './components/Bookings/myBookings';
import ZipcodeGate from './components/ZipCode/zipCodeGate';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import HomePage from './components/HomePage/HomePage';
import Profile from './components/Users/userProfile';
import PrivacyPolicy from './components/Pages/PrivacyPolicy';
import TermsOfService from './components/Pages/TermsOfService';
import BlogList from './components/Blog/blogList';
import BlogPost from './components/Blog/blogPost';
import HotelPage from './components/HotelPage/HotelPage';
import BookingSuccess from './components/Bookings/BookingSuccess';
import BookingCancelled from './components/Bookings/BookingCancelled';

import AdminDashboard from './components/Admin/AdminDashboard';
import StorePage from './components/Store/StorePage';
import StoreResult from './components/Store/StoreResult';
import ProductPage from './components/Store/ProductPage';

function App() {
  const { user } = useSelector((state) => state.auth);

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/rooms" />} />
        <Route path="/register" element={!user ? <Register /> : <Navigate to="/rooms" />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/booking-success" element={<BookingSuccess />} />
        <Route path="/booking-cancelled" element={<BookingCancelled />} />

        {/* Route for zipcode validation page (optional) */}
        <Route path="/validate-zip" element={<ZipcodeGate />} />

        {/* Protected routes */}
        <Route path="/bookings/new" element={user ? <BookingForm /> : <Navigate to="/login" />} />
        <Route path="/my-bookings" element={user ? <MyBookings /> : <Navigate to="/login" />} />
        <Route path="/profile" element={user ? <Profile /> : <Navigate to="/login" />} />
        <Route path="/bookings/new" element={user ? <BookingForm /> : <Navigate to="/login" />} />
        <Route path="/admin" element={user?.isAdmin ? <AdminDashboard /> : <Navigate to="/" />} />

        {/* Public hotel content */}
        <Route path="/hotel" element={<HotelPage />} />
        <Route path="/store" element={<StorePage />} />
        <Route path="/store/product/:id" element={<ProductPage />} />
        <Route path="/store/success" element={<StoreResult success />} />
        <Route path="/store/cancelled" element={<StoreResult success={false} />} />
        <Route path="/rooms" element={<RoomList />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />

        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/rooms" />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;